import React from 'react'
import styled from 'styled-components'
import moment from '../../../../lib/moment.js'
import get from 'lodash/get'
import orderBy from 'lodash/orderBy'
import shortid from 'shortid'
import { FONTS } from '../../../../constants'

export const HourRow = (props) => {
  const sumHoursByDate = get(props, 'timesheetRequest.timesheetRequest.timesheet_snapshot.sumHoursByDate', [])
  let sumHours = []
  let total = 0
  Object.keys(sumHoursByDate).forEach(s => {
    sumHours.push({ date: s, hours: sumHoursByDate[s] })
    total += sumHoursByDate[s]
  })
  sumHours = orderBy(sumHours, ['date'], 'asc')
  return (
    <Wrapper id='printHourRow'>
      <HourText>Filled Hour</HourText>
      <Column>
        <Total>{ total }</Total>
        {sumHours.map(sum => {
          const isToday = moment(sum.date).isSame(moment(), 'day')
          return (
            <Cell key={ shortid() }>
              <Date isToday={ isToday }>{ sum.hours === 0 ? '' : sum.hours }</Date>
            </Cell>
          )
        })}
      </Column>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  background-color: #EEEEEE ;
  height: 40px;
  display: flex;
  flex-direction: row;
  flex: 1;
  align-items: center;
`
const Column = styled.div`
  height: 100%;
  background-color: #EEEEEE;
  flex: 1;
  overflow: hidden;
  display: flex;
  flex-direction: row;
  border: solid #EAEAEA;
  border-width: 0px 1px 0px 0px;
`
const Cell = styled.div`
  font-family: ${FONTS.GOTHAM_MEDIUM};
  font-size: ${FONTS.SMALL_SIZE};
  flex: 1;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border: solid #EAEAEA;
  border-width: 0px 1px 0px 0px;
`
const Date = styled.div`
  color: black;
`
const HourText = styled.div`
  width: 30%;
  margin-left: 1% !important;
  margin-right: 1% !important;
  font-family: ${FONTS.GOTHAM};
  font-size: ${FONTS.SMALL_SIZE};
`
const Total = styled.span`
  width: 50px;
  font-family: ${FONTS.GOTHAM_MEDIUM};
  font-size: ${FONTS.SMALL_SIZE};
  text-align: center;
  margin-top: 10px;
  margin-bottom: 10px;
`



// WEBPACK FOOTER //
// ./src/components/timesheet/tab-content/timesheet-status/hour-row.js